import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Col } from "reactstrap";
import PDFIcon from "../../assets/images/pdficon.svg"; // adjust path as needed
import { getOssClient } from "../../Common/Utils/ossUtils";

export default function UploadImage({
  update,
  prop,
  formik,
  files,
  setFiles,
  type, // "onlyimage" or undefined
}) {
  const isOptionalField = prop?.title?.toLowerCase?.().includes("optional");
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [inputKey, setInputKey] = useState(Date.now());

  const onDrop = (acceptedFiles) => {
    if (!acceptedFiles?.length) return;

    const selectedFile = acceptedFiles[0];
    setFiles(selectedFile);
    handleImageUpload(selectedFile);

    // Force Dropzone remount to allow same file re-upload
    setInputKey(Date.now());
  };

  const handleImageUpload = async (file) => {
    if (!file) return;

    try {
      const ossClient = await getOssClient();
      const fileName = `images/${Date.now()}_${file.name}`;

      const result = await ossClient.put(fileName, file, {
        progress: (p) => setUploadProgress(Math.round(p * 100)),
        mimeType: file.type,
      });

      formik.setFieldValue(prop.name, result.url);
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  const acceptFiles =
    type === "onlyimage"
      ? { "image/*": [".jpg", ".jpeg", ".png"] }
      : {
          "image/*": [".jpg", ".jpeg", ".png"],
          "application/pdf": [".pdf"],
        };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: acceptFiles,
  });

  useEffect(() => {
    if (files) {
      const url = URL.createObjectURL(files);
      setPreviewUrl(url);

      return () => URL.revokeObjectURL(url); // Cleanup
    }
  }, [files]);

  const getPreviewSrc = () => {
    const value = formik.values[prop.name];

    // If it's a PDF and not image-only mode
    if (
      value &&
      value.toLowerCase().endsWith(".pdf") &&
      type !== "onlyimage"
    ) {
      return PDFIcon;
    }

    return previewUrl || value;
  };

  return (
    <Col xs={4}>
      <label>{prop.title}</label>

      <div
        key={inputKey} // <== Important for Dropzone remount
        {...getRootProps({ className: "dropzone" })}
        style={{
          border: "1px dashed #ddd",
          padding: "20px",
          cursor: "pointer",
        }}
      >
        <input {...getInputProps()} />
        {files ? (
          <p>Selected: {files.name}</p>
        ) : (
          <p>
            Drag & drop {type === "onlyimage" ? "an image" : "an image or PDF"}{" "}
            here, or click to select
          </p>
        )}
      </div>

      {formik.touched[prop.name] && formik.errors[prop.name] && (
        <div className="error" style={{ color: "red" }}>
          {formik.errors[prop.name]}
        </div>
      )}

      <p className="fontsizes">
        {isOptionalField ? (
          <>Optional upload: {type === "onlyimage"
            ? "image only (JPG, PNG, JPEG)"
            : "PDF or image (JPG, PNG, JPEG)"}</>
        ) : (
          <>
            <strong style={{ color: "red" }}>*</strong>{" "}
            Please upload {type === "onlyimage"
              ? "an image (JPG, PNG, JPEG) only"
              : "a PDF or an image (JPG, PNG, JPEG)"}
          </>
        )}
      </p>

      <Col md={1}>
        {update && formik.values[prop.name] ? (
          <img
            onClick={() => window.open(formik.values[prop.name], "_blank")}
            style={{ width: "140px", paddingTop: "5px", cursor: "pointer" }}
            src={getPreviewSrc()}
            alt="Preview"
          />
        ) : previewUrl ? (
          <img
            onClick={() => window.open(formik.values[prop.name], "_blank")}
            style={{ width: "140px", paddingTop: "5px", cursor: "pointer" }}
            src={getPreviewSrc()}
            alt="Preview"
          />
        ) : null}
      </Col>
    </Col>
  );
}
